
import { IVenderActionTypes } from "../../action-types/user/IVenderActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IVenderReducer } from "../../reducer-model/user/IVenderReducer";
const iniState: IVenderReducer = {
  status: eReducerStatusBase.is_not_initialization,
  venders: []
};
export const venderReducer = (
  state: IVenderReducer = iniState,
  action: IVenderActionTypes
): IVenderReducer => {
  switch (action.type) {
    case "VENDER_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "VENDER_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        venders: action.payload,
      };
    case "VENDER_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "VENDER_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        venderEditing: action.payload
      };
    case "VENDER_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "VENDER_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "VENDER_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false
      };
    case "VENDER_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "VENDER_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "VENDER_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "VENDER_DELETE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
   
    default:
      return state;
  }
};
